module.exports = __webpack_public_path__ + "static/media/tire-damage.241260e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/driverpolicy-images/tire-damage.png
// module id = 1327
// module chunks = 0